import React from "react";
import "./Opt_For_Counselling.css";
import Common_Title from "../../common/common-title/Common_Title";

const Opt_For_Counselling = ({whoshouldopt}) => {
  const targetGroups = [
    "Students choosing their academic stream",
    "Students planning higher education",
    "Students unsure about career direction",
    "Students seeking structured career guidance",
  ];
  return (
    <section className="Opt_For_Counselling">
      <div className="container">
        <Common_Title title="Who Should Opt for Career Counselling?" />
      </div>

      <div className="container-fluid p-0">
        <div className="opt_div_holder">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-12 p-0">
              <div className="opt_img_div">
                <img
                  src="/assets/images/Career_Counselling/opt-for-career-counselling/img-1.png"
                  alt="opt-img"
                  className="opt_img"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className="list_div">
                <ul className="guidance_list">
                  {whoshouldopt?.map((item, index) => (
                    <li key={index} className="guidance_item">
                      {item?.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Opt_For_Counselling;
